import { v4 as uuidv4 } from "uuid"

export const navbar = [
  {
    id: uuidv4(),
    title: "Home",
    url: "/",
  },
  {
    id: uuidv4(),
    title: "Accessories",
    url: "/accessories",
  },
]

export const accessories = [
  {
    id: uuidv4(),
    title: "Car / Office lumbar support",
    price: "KES 1,500.00",
    desc: "Polyester mesh fabric car/office lumbar back and lower back support",
    features: [
      {
        id: uuidv4(),
        text: "Makes you comfortable while driving/working at the office",
      },
      {
        id: uuidv4(),
        text: "Helps you minimize back pains",
      },
      {
        id: uuidv4(),
        text: "Massages the back and lumbar spine",
      },
    ],
    image: "https://i.ibb.co/Ns6y88C/Collection.jpg",
  },
  // {
  //   id: uuidv4(),
  //   title: "Electric USB heating cup / smart mug",
  //   price: "KES 1,500.00",
  //   desc: "Very easy and efficient to use",
  //   features: [
  //     "12V 450ml",
  //     "Electric car cup safe and convenient",
  //     "Travel USB heating car cup",
  //     "Coffee / Tea maker",
  //     "Stainless steel mug",
  //   ],
  //   image: "https://i.ibb.co/Ns6y88C/Collection.jpg",
  // },
]
